import { useBookingContext } from "modules/Booking/BookingContext"
import { Spinner } from "components/Spinner"
import { NextPageButtonWithAdditionalInfo } from "modules/Booking/SessionDatePage/components/NextPageButtonWithAdditionalInfo"
import { SessionInfo } from "modules/Booking/FormPage/common/SessionInfo"

export function SessionInfoCard() {
    const [{ datePickerError, selectedTime, datePickerIsLoaded }] = useBookingContext()

    if (!selectedTime) return null

    return (
        <div className="session-date__session-info-container">
            {datePickerError === undefined && !datePickerIsLoaded && (
                <div className="session-date__session-info session-date__session-info__skeleton">
                    <Spinner />
                </div>
            )}
            {datePickerError === undefined && datePickerIsLoaded && (
                <div className="session-date__session-info">
                    <SessionInfo />
                    <NextPageButtonWithAdditionalInfo regimen="desktop" />
                </div>
            )}
        </div>
    )
}
